import Platform from './Platform'
import * as nativeApi from '../../api/index'
import * as nativeComponentApi from '../../api/nativeComponentAPI'

class Ios extends Platform {
  constructor() {
    super()
  }

  // IOS 下禁用页面滑动反弹
  toggleBouncesOff() {
    nativeApi.toggleBouncesOff()
  }

  // IOS 下启用页面滑动反弹
  toggleBouncesOn() {
    nativeApi.toggleBouncesOn()
  }

  /**
    * 预加载storeKit
    * @param params
    * @returns {*|Promise<any>}
    */
  preloadStoreKit (params = {}) {
    nativeComponentApi.preloadStoreKit(params)
  }

  /**
  * 添加stk到父视图
  * @param params
  * @returns {*|Promise<any>}
  */
  addStoreKitTo (params = {}) {
    nativeComponentApi.addStoreKitTo(params)
  }

  /**
   * 为increaseOfferFrequenceForRvIv接口组成要发送的数据
   * @param campaign {Object}
   */
  prepareDataForIncOfferFreRvIv(campaign = {}) {
    const dataSend = campaign
    return dataSend
  }
}

export default Ios